import * as React from "react";
/* empty css                    */
const SliderCarousel = ({ children, itemWidth = 280 }) => /* @__PURE__ */ React.createElement("ul", { className: "slider-carousel" }, React.Children.map(children, (child, i) => /* @__PURE__ */ React.createElement(
  "li",
  {
    key: i,
    className: "slider-carousel__item",
    style: { minWidth: `calc(${itemWidth}px + 1rem)` }
  },
  child
)));
export {
  SliderCarousel as default
};
//# sourceMappingURL=SliderCarousel.js.map
